import React from 'react'
import { IIconProps } from '../types/types'

const SurpriseIcon: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        aria-hidden='true' focusable='false' data-prefix='far' data-icon='surprise'
        className='svg-inline--fa fa-surprise fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '14px'}
        width={props.width ? props.width : '14px'}
        viewBox='0 0 496 512'
      >
        <path
          fill={props.color}
          d='M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'
        />
      </svg>
    </>
  )
}

export default SurpriseIcon
